<template>
    <Tree
        :items="items"
        :activeIds="activeIds"
        @itemClick="selectItem"
    />
</template>

<script>
    import { mapGetters } from 'vuex';
    import { routeNames } from '@app/router/constants';

    export default {
        computed: {
            ...mapGetters('data/games', [
                'virtualShopsGames',
            ]),
            items() {
                return this.virtualShopsGames.map((t) => ({
                    name: t.name,
                    id: t.name,
                }));
            },
            activeIds() {
                const selectedItem = this.$route.params.gameType || this.virtualShopsGames[0].name;
                return [selectedItem];
            }
        },
        methods: {
            selectItem([item]) {
                const {
                    params: {
                        date: dateParam,
                    },
                } = this.$route;

                const params = {
                    date: dateParam,
                };
                this.$router.replace({
                    name: routeNames.virtualShopsResults,
                    params: {
                        gameType: item.id,
                        ...params
                    }
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/results/leftSidebar/ShopsSidebar.vue